export const SESSION_DURATION = 14 * 60
export const SESSION_STORAGE_KEY = 'session_end_time'

export function startSession() {
  const endTime = Date.now() + SESSION_DURATION * 1000
  sessionStorage.setItem(SESSION_STORAGE_KEY, endTime.toString())
  return SESSION_DURATION
}

export function clearSession() {
  sessionStorage.removeItem(SESSION_STORAGE_KEY)
}
